import React, { useEffect, useRef, useState } from 'react';
import noop from 'lodash/noop';

import { cn } from '@lyearn/style';
import { BaseMenuList, ClickAwayListener, Loader, Popper, Stack } from '@lyearn/ui';
import useHandleKeyDown from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/plugins/Mentions/hooks/useHandleKeyDown';

import { PopperListProps } from './types';

function PopperList<T>(props: PopperListProps<T>) {
  const {
    items,
    className,
    popperProps,
    renderItem,
    searchString,
    onClose,
    onItemClick,
    fetching,
  } = props;

  const ref = useRef<HTMLUListElement>(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);

  useHandleKeyDown({ ref, items, onItemClick, selectedItemIndex, setSelectedItemIndex, onClose });

  useEffect(() => {
    setSelectedItemIndex(0);
  }, [searchString]);

  useEffect(() => {
    if (!items.length && !fetching) {
      onClose?.();
    }
  }, [onClose, items.length, fetching, items]);

  return (
    <ClickAwayListener onClickAway={onClose || noop}>
      <Popper
        open
        className={cn(
          className,
          'z-20 my-8 overflow-y-auto rounded-8 border border-divider bg-bg-primary shadow-01',
        )}
        {...popperProps}>
        {fetching ? (
          <Stack alignItems="center" className="h-48 flex-1" justifyContent="center">
            <Loader />
          </Stack>
        ) : (
          <BaseMenuList ref={ref} className="space-y-2 p-8 outline-none">
            {items.map((item, index) => renderItem(item, index, selectedItemIndex === index))}
          </BaseMenuList>
        )}
      </Popper>
    </ClickAwayListener>
  );
}

export default PopperList;
